import type { RouteRecordRaw } from 'vue-router';

import { ROUTES } from '@/constants/routes';
import i18n from '@/i18n';

import type { BreadcrumbProps } from '@/dsComponents/breadcrumbs/types';

const routes: RouteRecordRaw[] = [
	{
		path: 'mon-profil',
		name: ROUTES.APP.PROFILE._ROOT,
		component: () => import('./views/profile/Layout.vue'),
		redirect: { name: ROUTES.APP.PROFILE.INFOS },
		meta: {
			breadcrumbs: <BreadcrumbProps>{
				items: [
					{
						label: i18n.global.t('breadcrumbs.profil.root'),
						icon: 'user',
					},
				],
			},
		},
		children: [
			{
				path: '',
				name: ROUTES.APP.PROFILE.INFOS,
				component: () => import('./views/profile/ProfileInfos.vue'),
			},
			{
				path: 'notifications',
				name: ROUTES.APP.PROFILE.NOTIFICATIONS,
				component: () => import('./views/profile/ProfileNotifications.vue'),
			},
			{
				path: 'mot-de-passe',
				name: ROUTES.APP.PROFILE.PASSWORD,
				component: () => import('./views/profile/ProfilePassword.vue'),
			},
		],
	},
];

export default routes;
